// ----------------------------------------------------------------------
// Legal / policy configuration — single source of truth for the Terms of
// Service and Privacy Policy versions, effective dates and company details.
//
// Bump the *_VERSION string whenever the corresponding policy text changes.
// The acceptance gate (see components/PolicyAcceptanceModal) compares the
// version a signed-in user last accepted against these values and re-prompts
// them to accept when they differ.
//
// NOTE: The policy copy in components/_external-pages/legal is a solid,
// ResiView-tailored starting point but has NOT been reviewed by an attorney.
// Have counsel review before relying on it in production.
// ----------------------------------------------------------------------

// Version identifiers. Keep these as opaque strings — any change (date bump,
// wording change) that requires re-acceptance should change the value.
export const TERMS_VERSION = '2026-07-18';
export const PRIVACY_VERSION = '2026-07-18';

// Human-readable "Last updated" dates shown at the top of each policy.
export const TERMS_EFFECTIVE_DATE = 'July 18, 2026';
export const PRIVACY_EFFECTIVE_DATE = 'July 18, 2026';

// Company / contact details referenced throughout the policies.
export const LEGAL_COMPANY = {
  name: 'TKG, LLC',
  product: 'ResiView',
  address: '8012 Apache Rd, Lenexa, KS',
  country: 'Kansas, United States',
  website: 'https://resiview.com',
  websiteLabel: 'resiview.com',
  supportEmail: 'support@resiview.com',
  privacyEmail: 'feedback@resiview.com'
};

export default {
  TERMS_VERSION,
  PRIVACY_VERSION,
  TERMS_EFFECTIVE_DATE,
  PRIVACY_EFFECTIVE_DATE,
  LEGAL_COMPANY
};
